import { AppDispatch } from '@app/store/store';
import { BalanceActionType, PriceType } from '@app/shared/types/common';
import { balanceApi } from '@app/store/slices/balance/balanceApi';
import { userProgressApi } from '@app/store/slices/userProgress/userProgressApi';
import { UserProgressTagType } from '@app/store/slices/userProgress/userProgressTypes';
import { PracticeRewardData } from '@app/store/slices/users/usersTypes';
import { ApiResponse } from './common';

export const updateBalance = (
  type: PriceType,
  action: BalanceActionType,
  value: number,
  dispatch: AppDispatch
) => {
  dispatch(
    balanceApi.util.updateQueryData('getBalance', undefined, (draft) => {
      if (!draft) {
        return;
      }

      const balanceKey = type === PriceType.COOKIE ? 'cookieBalance' : 'tonBalance';

      const currentBalance = Number(draft[balanceKey]);

      const updatedBalance =
        action === BalanceActionType.INCREASE ? currentBalance + value : currentBalance - value;

      draft[balanceKey] = updatedBalance.toString();
    })
  );
};

export const updateCurrentXp = async (
  earnedXp: number,
  dispatch: AppDispatch,
  queryFulfilled: Promise<unknown>
) => {
  const patchResult = dispatch(
    userProgressApi.util.updateQueryData('getCurrentUserProgress', undefined, (draft) => {
      if (!draft) {
        return;
      }

      draft.xp = Math.min(draft.xp + earnedXp, draft.xpNextLevel);
    })
  );

  try {
    await queryFulfilled;

    dispatch(userProgressApi.util.invalidateTags([UserProgressTagType.CURRENT_USER_PROGRESS]));
  } catch {
    patchResult.undo();
  }
};

export const updateCurrentXpFromResponse = async (
  dispatch: AppDispatch,
  queryFulfilled: Promise<{
    data: ApiResponse<PracticeRewardData>;
  }>
) => {
  const patchResult = dispatch(
    userProgressApi.util.updateQueryData('getCurrentUserProgress', undefined, () => {
      // optimistic не делаем — потому что не знаем xp до ответа
    })
  );

  try {
    const { data: resp } = await queryFulfilled;

    if (!resp.data?.xpAwarded) {
      return;
    }

    dispatch(
      userProgressApi.util.updateQueryData('getCurrentUserProgress', undefined, (draft) => {
        if (!draft) {
          return;
        }

        draft.xp = Math.min(draft.xp + (resp.data?.xpAwarded ?? 0), draft.xpNextLevel);
      })
    );

    dispatch(userProgressApi.util.invalidateTags([UserProgressTagType.CURRENT_USER_PROGRESS]));

    if (resp.data.cookiesAwarded) {
      updateBalance(
        PriceType.COOKIE,
        BalanceActionType.INCREASE,
        resp.data.cookiesAwarded,
        dispatch
      );
    }
  } catch {
    patchResult.undo();
  }
};
